import { BrowserRouter, Route, Switch } from 'react-router-dom'

import RootApp from './pages/App'
import HostedCardFields from './pages/HostedCardFields'
import HostedPaymentPage from './pages/HostedPaymentPage'
import HostedPaymentReturnPage from './pages/HostedPaymentReturnPage'

import "./assets/scss/app.scss";

function App() {

  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={RootApp} />
          <Route exact path="/embedded-card-fields" component={HostedCardFields} />
          <Route exact path="/hosted-payment-page" component={HostedPaymentPage} />
          <Route exact path="/hosted-payment-return" component={HostedPaymentReturnPage} />
        </Switch>
      </BrowserRouter>
    </>
  );
}

export default App;
